import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "t6_table_b" }
const _hoisted_2 = { class: "input_td" }
const _hoisted_3 = { class: "input_td" }
const _hoisted_4 = { class: "input_td" }
const _hoisted_5 = {
  class: "input_td text",
  colspan: "3"
}
const _hoisted_6 = { style: {"float":"left","width":"160px"} }
const _hoisted_7 = { style: {"float":"left","cursor":"pointer"} }
const _hoisted_8 = { class: "tip" }
const _hoisted_9 = { class: "tip_icon" }
const _hoisted_10 = { class: "input_td" }
const _hoisted_11 = { class: "input_td" }
const _hoisted_12 = { class: "input_td" }
const _hoisted_13 = { class: "input_td" }

import { getLoginUser } from "@/config/request";
import { reactive, ref, toRefs } from "vue";
import { useStore } from "vuex";
import { Warning } from '@element-plus/icons-vue';
import cityMapJSON from '@/config/cityMap'


export default /*@__PURE__*/_defineComponent({
  __name: 'form',
  props: {
    publicData:Object
},
  setup(__props, { expose: __expose }) {

const props = __props
const { publicData } = toRefs(props) as any

const cityMap = JSON.parse(JSON.stringify(cityMapJSON))
const tree = ref(null) as any
const changeSelectCityLevel = (address:any) => {
    let nodes = tree.value.getCheckedNodes()
    publicData.value.basicInfo.preExpress.receiveRegionCode = nodes[0].data.cityCode || ''    //  选中的区划编码
    let selectCityLevel = address //  选择邮寄收件地址用-省市县
    publicData.value.basicInfo.preExpress.receiveProvince = selectCityLevel[0] || ''
    publicData.value.basicInfo.preExpress.receiveCity = selectCityLevel[1] || ''
    publicData.value.basicInfo.preExpress.receiveCounty = selectCityLevel[2] || ''
}

const store = useStore()
const userInfo = store.state.userInfomation

const data = reactive({
    applyCardnumber:'',
    formType: 0,    //  用户表单类型
})

publicData.value.basicInfo.preApasinfo.applyname = userInfo.userName;
data.applyCardnumber = userInfo.certNo;
publicData.value.basicInfo.preApasinfo.applyCardnumber = userInfo.certNo;
//获取用户在线办理类型
publicData.value.basicInfo.preApasinfo.userType = userInfo.userType;
publicData.value.basicInfo.preApasinfo.certificateSno = userInfo.certificateSno;
publicData.value.basicInfo.preApasinfo.corpName = userInfo.corpName;
// 暂时注释 让用户自己填手机号
publicData.value.basicInfo.preApasinfo.telphone = userInfo.userMobile
publicData.value.basicInfo.preApasinfo.contactman = userInfo.userName
publicData.value.basicInfo.preApasinfo.contactmanCardnumber = userInfo.certNo

let selectServiceCode = publicData.value.basicInfo.preApasinfo.servicecode;
publicData.value.basicInfo.preApasinfo.servicecode = selectServiceCode;
// 默认值
publicData.value.basicInfo.preApasinfo.applyType = '1';
publicData.value.basicInfo.preApasinfo.applyCardtype = '居民身份证';
publicData.value.basicInfo.preApasinfo.contactmanCardtype = '居民身份证';

if(userInfo.userType == 1){
    data.formType = 1;
    publicData.value.basicInfo.preApasinfo.applyCardtype = '居民身份证';
    publicData.value.basicInfo.preApasinfo.contactmanCardtype = '居民身份证';
}else if(userInfo.userType ==2){
    data.formType = 2;
    publicData.value.basicInfo.preApasinfo.applyCardtype = '统一社会信用代码证';
    publicData.value.basicInfo.preApasinfo.contactmanCardtype = '居民身份证';
}else{
    data.formType = 1;
    publicData.value.basicInfo.preApasinfo.applyCardtype = '居民身份证';
    publicData.value.basicInfo.preApasinfo.contactmanCardtype = '居民身份证';
}
const cardTypes = [{code: '居民身份证', name: "居民身份证"},
    {code: '临时居民身份证', name: "临时居民身份证"},
    {code: '户口簿', name: "户口簿"},{code: '中国人民解放军军官证', name: "中国人民解放军军官证"},{code: '中国人民武装警察部队警官证', name: "中国人民武装警察部队警官证"},
    {code: '出生医学证明', name: "出生医学证明"},{code: '中国人民解放军士兵证', name: "中国人民解放军士兵证"},{code: '中国人民武装警察部队士兵证', name: "中国人民武装警察部队士兵证"},
    {code: '中国人民解放军文职人员证', name: "中国人民解放军文职人员证"},{code: '法官证', name: "法官证"},{code: '中国人民武装警察部队文职人员证', name: "中国人民武装警察部队文职人员证"},
    {code: '居住证', name: "居住证"},{code: '外交护照', name: "外交护照"},{code: '公务护照', name: "公务护照"},
    {code: '公务普通护照', name: "公务普通护照"},{code: '普通护照', name: "普通护照"},{code: '旅行证', name: "旅行证"},{code: '外国人旅行证', name: "外国人旅行证"},
    {code: '台湾居民来往大陆通行证', name: "台湾居民来往大陆通行证"},{code: '港澳居民来往内地通行证', name: "港澳居民来往内地通行证"},{code: '外国人永久居留身份证', name: "外国人永久居留身份证"},{code: '554', name: "外国人居留证或居留许可"},
    {code: '外国人临时居留证', name: "外国人临时居留证"},{code: '外交人员身份证明', name: "外交人员身份证明"},{code: '境外人员身份证明', name: "境外人员身份证明"},{code: '驻华机构证明', name: "驻华机构证明"},{code: '其他', name: "其他"}]
const cardTypesFr = [{code: '统一社会信用代码证', name: "统一社会信用代码证"},{code: '其他法人或其他组织有效证件', name: "其他法人或其他组织有效证件"},{code: '营业执照', name: "营业执照"},
    {code: '律师事务所执业许可证', name: "律师事务所执业许可证"},]

const getFormData = () => {
    return publicData?.value
}
__expose({
    getFormData
})
const init = async() => {
 // 获取登录用户基本信息 这里返回固定值
    const res = await getLoginUser('') as any

    publicData.value.basicInfo.userName = res.userName;
    publicData.value.basicInfo.preApasinfo.dataversion = res.dataversion;
    publicData.value.basicInfo.preApasinfo.receiveName = res.receiveName;
    publicData.value.basicInfo.preApasinfo.receiveUseid = res.receiveUseid;
    publicData.value.basicInfo.preApasinfo.resultAccess = res.resultAccess;
    publicData.value.basicInfo.preApasinfo.serviceversion = res.serviceversion;
    publicData.value.basicInfo.preApasinfo.belongsystem = res.belongsystem;

}
init()

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      model: _unref(publicData),
      class: "demo-form-inline",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_1, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _cache[8] || (_cache[8] = _createElementVNode("th", null, "事项名称", -1)),
              _createElementVNode("td", null, _toDisplayString(_unref(publicData).basicInfo.preApasinfo.servicename), 1),
              _cache[9] || (_cache[9] = _createElementVNode("th", null, "申请人姓名", -1)),
              _createElementVNode("td", null, _toDisplayString(_unref(publicData).basicInfo.preApasinfo.applyname), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[10] || (_cache[10] = _createElementVNode("th", null, "事项编号", -1)),
              _createElementVNode("td", null, _toDisplayString(_unref(publicData).basicInfo.preApasinfo.servicecode), 1),
              _cache[11] || (_cache[11] = _createElementVNode("th", null, "证件类型", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("td", null, "身份证", -1))
            ]),
            _createElementVNode("tr", null, [
              _cache[13] || (_cache[13] = _createElementVNode("th", null, "证件号码", -1)),
              _createElementVNode("td", null, _toDisplayString(data.applyCardnumber), 1),
              _cache[14] || (_cache[14] = _createElementVNode("th", null, "申报类型", -1)),
              _createElementVNode("td", null, _toDisplayString(_unref(userInfo).userType == '1'?'法人':'自然人'), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[15] || (_cache[15] = _createElementVNode("th", null, "联系人姓名", -1)),
              _createElementVNode("td", _hoisted_2, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(publicData).basicInfo.preApasinfo.contactman) = $event)),
                  maxlength: "20"
                }, null, 512), [
                  [_vModelText, _unref(publicData).basicInfo.preApasinfo.contactman]
                ])
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("th", null, "联系人手机", -1)),
              _createElementVNode("td", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(publicData).basicInfo.preApasinfo.telphone) = $event)),
                  maxlength: "20"
                }, null, 512), [
                  [_vModelText, _unref(publicData).basicInfo.preApasinfo.telphone]
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[17] || (_cache[17] = _createElementVNode("th", null, "联系人证件类型", -1)),
              _createElementVNode("td", null, _toDisplayString(_unref(publicData).basicInfo.preApasinfo.contactmanCardtype), 1),
              _cache[18] || (_cache[18] = _createElementVNode("th", null, "联系人证件号码", -1)),
              _createElementVNode("td", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(publicData).basicInfo.preApasinfo.contactmanCardnumber) = $event)),
                  maxlength: "20"
                }, null, 512), [
                  [_vModelText, _unref(publicData).basicInfo.preApasinfo.contactmanCardnumber]
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[21] || (_cache[21] = _createElementVNode("th", null, "是否需要结果邮递", -1)),
              _createElementVNode("td", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_switch, {
                    modelValue: _unref(publicData).basicInfo.preApasinfoRelation.isJgydStatus,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(publicData).basicInfo.preApasinfoRelation.isJgydStatus) = $event)),
                    size: "large",
                    "active-text": "是",
                    "inactive-text": "否"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_tooltip, { placement: "top" }, {
                    content: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                      _createElementVNode("div", { style: {"width":"300px"} }, [
                        _createElementVNode("div", null, " 结果邮寄免责说明: "),
                        _createElementVNode("div", { style: {"text-indent":"2em"} }, " 本人（或单位）委托中国（河南）自由贸易试验区开封片区综合服务中心通过河南省邮政邮寄， 为了避免引起纠纷特做如下说明，因邮寄出现丢失、破损等现象而造成的无法正常收件的后果，由本人自行负责。 ")
                      ], -1)
                    ]))]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "tip_text" }, " 温馨提示 ", -1)),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_unref(Warning), { class: "icon" })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            (_unref(publicData).basicInfo.preApasinfoRelation.isJgydStatus)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("tr", null, [
                    _cache[22] || (_cache[22] = _createElementVNode("th", null, "收件人姓名", -1)),
                    _createElementVNode("td", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(publicData).basicInfo.preExpress.receiveName) = $event)),
                        maxlength: "20"
                      }, null, 512), [
                        [_vModelText, _unref(publicData).basicInfo.preExpress.receiveName]
                      ])
                    ]),
                    _cache[23] || (_cache[23] = _createElementVNode("th", null, "联系方式", -1)),
                    _createElementVNode("td", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(publicData).basicInfo.preExpress.receivePhone) = $event)),
                        maxlength: "20"
                      }, null, 512), [
                        [_vModelText, _unref(publicData).basicInfo.preExpress.receivePhone]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[24] || (_cache[24] = _createElementVNode("th", null, "城市/区划", -1)),
                    _createElementVNode("td", _hoisted_12, [
                      _createVNode(_component_el_cascader, {
                        style: {"width":"95%","z-index":"2000"},
                        modelValue: _unref(publicData).basicInfo.addressee.areaCode,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(publicData).basicInfo.addressee.areaCode) = $event)),
                        options: _unref(cityMap),
                        ref_key: "tree",
                        ref: tree,
                        props: { expandTrigger: 'click',value:'cityName',label:'cityName',children:'counties' },
                        onChange: changeSelectCityLevel
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _cache[25] || (_cache[25] = _createElementVNode("th", null, "详细地址", -1)),
                    _createElementVNode("td", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(publicData).basicInfo.preExpress.receiveAddr) = $event)),
                        maxlength: "100"
                      }, null, 512), [
                        [_vModelText, _unref(publicData).basicInfo.preExpress.receiveAddr]
                      ])
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})